import React, { useState } from 'react';
import {
  BarChart3, FolderOpen, Shield, MessageCircle,
  Users, UserCheck, Calculator,
  TrendingUp, MapPin, Award, Calendar,
  Building2, Link2, Network, Headphones,
  Receipt, CreditCard, Gift,
  Settings, ChevronDown, ChevronRight, Search, Trash2, X, SlidersHorizontal, BookOpen, Percent, AlertCircle, Wrench, Globe
} from 'lucide-react';
import { Input } from '../ui/input';
import InfoTooltip from './InfoTooltip';

const NAV_CATEGORIES = [
  {
    id: 'operations',
    label: 'Opérations',
    icon: FolderOpen,
    color: 'text-blue-600',
    description: "Ce qu'il faut traiter au quotidien : dossiers, chantiers, messages.",
    items: [
      { id: 'overview', label: 'Vue d\'ensemble', icon: BarChart3, description: "Tableau de bord : chiffre d'affaires, leads du jour, paiements récents." },
      { id: 'projects', label: 'Dossiers', icon: FolderOpen, description: "Audits immobiliers en cours (clients Audit Pro)." },
      { id: 'chantiers', label: 'Chantiers VIP', icon: Shield, description: "Demandes Suivi de Travaux. À appeler pour négocier en direct (pas de paiement en ligne)." },
      { id: 'messaging', label: 'Messagerie', icon: MessageCircle, description: "Messages entrants des clients (chat Hotline + tickets Conseil)." },
    ]
  },
  {
    id: 'equipe',
    label: 'Équipe',
    icon: Users,
    color: 'text-emerald-600',
    description: "Gestion des collaborateurs internes.",
    items: [
      { id: 'analysts', label: 'Analystes', icon: UserCheck, description: "Tes collaborateurs qui rédigent les rapports d'audit." },
      { id: 'chiffreurs', label: 'Chiffreurs', icon: Calculator, description: "Tes collaborateurs qui font les estimations de travaux." },
    ]
  },
  {
    id: 'commercial',
    label: 'Commercial',
    icon: TrendingUp,
    color: 'text-purple-600',
    description: "La partie la plus importante : leads, clients, ventes, RDV.",
    items: [
      { id: 'prospects', label: 'Prospects', icon: TrendingUp, description: "TOUS les leads capturés (Estimation, Radar, Conseil, etc.). ICI on voit 100% du trafic." },
      { id: 'users', label: 'Clients', icon: Users, description: "Comptes clients créés — personnes ayant payé ou pris en charge par un partenaire." },
      { id: 'prospection', label: 'Prospection Proprio', icon: MapPin, description: "Demandes Radar Foncier (49€). Identifier les propriétaires d'une parcelle." },
      { id: 'conseil', label: 'Conseil VIP', icon: Award, description: "Demandes Conseil Stratégique payées (99€) : audits de devis, faisabilité, médiation, stratégie." },
      { id: 'appointments', label: 'Rendez-vous', icon: Calendar, description: "Tous les RDV pris via le calendrier interne (Conseil)." },
    ]
  },
  {
    id: 'reseau',
    label: 'Réseau',
    icon: Network,
    color: 'text-orange-600',
    description: "Marque blanche, partenaires, affiliés.",
    items: [
      { id: 'partners', label: 'Partenaires', icon: Building2, description: "Liste des partenaires marque blanche (artisans, agents immo…) avec leur sous-domaine." },
      { id: 'affiliates', label: 'Affiliés', icon: Link2, description: "Programme de parrainage et commissions d'affiliation." },
      { id: 'artisans', label: 'Artisans', icon: Wrench, description: "Sociétés de travaux validées (recevoir des chantiers qualifiés)." },
      { id: 'reseau-users', label: 'Utilisateurs', icon: Users, description: "Leads capturés à l'étape 1 du tunnel Réseau (email + choix). Suivez les abandons." },
      { id: 'network', label: 'À valider', icon: Network, description: "File d'attente : nouveaux inscrits Réseau (tous types) à valider/refuser." },
      { id: 'hotline', label: 'Hotline', icon: Headphones, description: "Chat en direct avec les partenaires." },
      { id: 'domaines', label: 'Domaines', icon: Globe, description: "Demandes de domaine des partenaires. Achetez et activez leur domaine custom." },
    ]
  },
  {
    id: 'finance',
    label: 'Finance',
    icon: Receipt,
    color: 'text-amber-600',
    description: "Comptabilité, abonnements, traitements offerts.",
    items: [
      { id: 'accounting', label: 'Comptabilité', icon: Receipt, description: "Toutes les factures émises avec export PDF. CA du mois." },
      { id: 'subscriptions', label: 'Abonnements', icon: CreditCard, description: "Abonnements partenaires (mensuels / annuels)." },
      { id: 'gratuites', label: 'Gratuités', icon: Gift, description: "Traitements offerts (échantillons, cadeaux commerciaux)." },
    ]
  },
  {
    id: 'systeme',
    label: 'Système',
    icon: Settings,
    color: 'text-gray-600',
    description: "Configuration technique de l'application.",
    items: [
      { id: 'settings', label: 'Paramètres', icon: Settings, description: "Infos entreprise (SIRET, TVA, RIB). Attention : impacte toutes les factures." },
      { id: 'estimation-coefs', label: 'Coefficients Estimation', icon: SlidersHorizontal, description: "Ajuster les % d'impact sur l'estimation (Balcon +3%, Rénové +10%, etc.)." },
      { id: 'product-catalog', label: 'Catalogue Prix Travaux', icon: Calculator, description: "Base de prix Fourniture/Pose utilisée par l'autocomplete du Dashboard Expert." },
      { id: 'loan-rates', label: 'Taux Crédit', icon: Percent, description: "Taux crédit immobilier 15/20/25 ans. Scraping auto Meilleurtaux + override manuel. Utilisé dans la simulation financière Expert." },
      { id: 'guide-complet', label: 'Guide Complet', icon: BookOpen, description: "Toutes les fonctionnalités expliquées (catalogue, fiches PDF, alertes réglementaires, fiscalité, documents obligatoires)." },
      { id: 'payment-errors', label: 'Logs Stripe', icon: AlertCircle, description: "Erreurs de paiement Stripe (clients qui n'ont pas pu payer). À traiter rapidement." },
      { id: 'purge', label: 'Purge Données', icon: Trash2, description: "⚠️ Vider les données test avant mise en production. IRRÉVERSIBLE." },
    ]
  },
];

export default function AdminSidebar({ activeTab, onTabChange, badges = {}, mobileOpen = false, onMobileClose = () => {} }) {
  const [expandedCategories, setExpandedCategories] = useState(() => {
    const initial = {};
    NAV_CATEGORIES.forEach(cat => {
      if (cat.items.some(item => item.id === activeTab)) {
        initial[cat.id] = true;
      }
    });
    if (Object.keys(initial).length === 0) initial['operations'] = true;
    return initial;
  });
  const [searchQuery, setSearchQuery] = useState('');

  const toggleCategory = (catId) => {
    setExpandedCategories(prev => ({ ...prev, [catId]: !prev[catId] }));
  };

  const handleItemClick = (itemId) => {
    onTabChange(itemId);
    onMobileClose();
  };

  const filteredCategories = searchQuery.trim()
    ? NAV_CATEGORIES.map(cat => ({
        ...cat,
        items: cat.items.filter(item =>
          item.label.toLowerCase().includes(searchQuery.toLowerCase())
        )
      })).filter(cat => cat.items.length > 0)
    : NAV_CATEGORIES;

  return (
    <>
      <aside className={`
        lg:w-56 lg:shrink-0 lg:relative lg:block
        ${mobileOpen ? 'block w-full' : 'hidden lg:block'}
      `} data-testid="admin-sidebar">
        <div className={`${mobileOpen ? 'h-full overflow-y-auto' : 'sticky top-6'} bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden`}>
          {/* Search */}
          <div className="p-3 border-b border-gray-100">
            <div className="relative">
              <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" />
              <Input
                data-testid="sidebar-search"
                placeholder="Rechercher..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-8 h-8 text-xs bg-gray-50 border-gray-200"
              />
            </div>
          </div>

          {/* Navigation */}
          <nav className="p-2 max-h-[calc(100vh-200px)] overflow-y-auto">
            {filteredCategories.map((category) => {
              const isExpanded = searchQuery.trim() ? true : expandedCategories[category.id];
              const CategoryIcon = category.icon;
            const hasActiveItem = category.items.some(item => item.id === activeTab);

            return (
              <div key={category.id} className="mb-1">
                <div className="w-full flex items-center">
                  <button
                    data-testid={`nav-category-${category.id}`}
                    onClick={() => toggleCategory(category.id)}
                    className={`flex-1 min-w-0 flex items-center justify-between px-3 py-2.5 rounded-lg text-[13px] font-extrabold uppercase tracking-widest transition-colors ${
                      hasActiveItem ? 'bg-gray-200 text-gray-900' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900'
                    }`}
                  >
                    <span className="flex items-center gap-2">
                      <CategoryIcon className={`w-3.5 h-3.5 ${category.color}`} />
                      {category.label}
                    </span>
                    {isExpanded
                      ? <ChevronDown className="w-3.5 h-3.5" />
                      : <ChevronRight className="w-3.5 h-3.5" />
                    }
                  </button>
                  {category.description && (
                    <div className="px-1.5">
                      <InfoTooltip text={category.description} size={12} />
                    </div>
                  )}
                </div>

                {isExpanded && (
                  <div className="mt-0.5 ml-2 space-y-0.5">
                    {category.items.map((item) => {
                      const ItemIcon = item.icon;
                      const isActive = activeTab === item.id;
                      const badge = badges[item.id];

                      return (
                        <div key={item.id} className="flex items-center">
                          <button
                            data-testid={`nav-item-${item.id}`}
                            onClick={() => handleItemClick(item.id)}
                            className={`flex-1 min-w-0 flex items-center justify-between px-3 py-1.5 rounded-lg text-sm transition-all ${
                              isActive
                                ? 'bg-[#0f1d3c] text-white font-medium shadow-sm'
                                : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                            }`}
                          >
                            <span className="flex items-center gap-2">
                              <ItemIcon className={`w-3.5 h-3.5 ${isActive ? 'text-amber-400' : ''}`} />
                              {item.label}
                            </span>
                            {badge > 0 && (
                              <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                                isActive ? 'bg-red-500 text-white' : 'bg-red-100 text-red-600'
                              }`}>
                                {badge}
                              </span>
                            )}
                          </button>
                          {item.description && (
                            <div className="px-1.5">
                              <InfoTooltip text={item.description} size={12} />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
        </div>
      </aside>
    </>
  );
}
